import React, { useState } from 'react';
import cn from 'classnames';
import { ChevronDown } from 'react-feather';
import { ActionList, Popover } from 'ui';
import { Trophy, OpenBook } from 'ui/Icon/Streamline';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import Tooltip from 'components/shared/Tooltip';

const AppSwitcher = ({ locale }) => {
  const [popoverOpen, setPopoverOpen] = useState(false);

  const buttonClasses = cn('d-f bs-n bdrs-4 ai-c AppSwitcher-button', {
    'AppSwitcher-button-closed': !popoverOpen,
    'AppSwitcher-button-open': popoverOpen,
  });

  const itemTextClass = locale.direction === 'rtl' ? 'mr-8' : 'ml-8';

  return (
    <div>
      <Popover
        isHighPriority
        rootClassName="d-f"
        align={locale.direction === 'rtl' ? 'right' : 'left'}
        visible={popoverOpen}
        onClose={() => setPopoverOpen(false)}
        activator={
          <Tooltip
            className={cn({ 'd-n': popoverOpen })}
            text={t('navbar.app_switcher.tooltip')}
            align={locale.direction === 'rtl' ? 'end' : 'start'}
          >
            <button
              type="button"
              onClick={() => setPopoverOpen(!popoverOpen)}
              className={buttonClasses}
              aria-label={t('navbar.app_switcher.button_label')}
            >
              <OpenBook />
              <ChevronDown size={16} />
            </button>
          </Tooltip>
        }
      >
        <div className="AppSwitcher-popover bdrs-4 f-o-n">
          <ActionList
            items={[
              {
                content: (
                  <>
                    <OpenBook />
                    <Text
                      variant={TEXT_VARIANTS.BODY_BOLD}
                      className={itemTextClass}
                    >
                      {t('navbar.app_switcher.training')}
                    </Text>
                  </>
                ),
                url: '/',
              },
              {
                content: (
                  <>
                    <Trophy />
                    <Text
                      variant={TEXT_VARIANTS.BODY}
                      className={itemTextClass}
                    >
                      {t('navbar.app_switcher.skills')}
                    </Text>
                  </>
                ),
                url: '/skills',
              },
            ]}
          />
        </div>
      </Popover>
    </div>
  );
};

export default props => <AppSwitcher {...props} />;
